import { render, staticRenderFns } from "./order-prices.vue?vue&type=template&id=022a2e4a&scoped=true&lang=pug&"
import script from "./order-prices.vue?vue&type=script&lang=js&"
export * from "./order-prices.vue?vue&type=script&lang=js&"
import style0 from "./order-prices.vue?vue&type=style&index=0&id=022a2e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022a2e4a",
  null
  
)

export default component.exports